import { default as OpportunitiesList } from './OpportunitiesList';

export default OpportunitiesList;
